import React, { useEffect, useState } from 'react';

const KEY = 'ff_theme';

export function ThemeProvider({ children }) {
  useEffect(() => {
    const saved = localStorage.getItem(KEY) || 'dark';
    document.documentElement.classList.toggle('dark', saved === 'dark');
  }, []);
  return <>{children}</>;
}

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || 'dark');
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem(KEY, next);
    document.documentElement.classList.toggle('dark', next === 'dark');
  };
  return { theme, toggle };
}
